export function range(start: number, end: number): Array<number> {
  let diff = end - start;

  const array = Array.of<number>();

  if (diff >= 0) {
    array.length = diff + 1;
  }

  while (diff >= 0) {
    array[diff] = start + diff;

    diff--;
  }

  return array;
}
